module.exports = __webpack_public_path__ + "static/media/sniper-4.cc7e1a67.png";